import Model from './BaseModel'
import User from './User'

export default class Tax extends Model {
    resourceName() {
        return 'commission/taxes'
    }

    fields() {
        return ['id', 'value', 'user_id', 'created_at']
    }

    relationships() {
        return {
            user: new User(),
        }
    }

    dates() {
        return {
            created_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedValue(tax) {
                return tax.value + '%'
            },

            createdUserName(tax) {
                return tax.user.name
            },

            formattedCreatedAt(tax) {
                return tax.created_at.format('DD/MM/YYYY HH:mm')
            },
        }
    }
}
